import React, { useState } from "react";
import InputIcon from "../../../gb-components/InputIcon";
import FileUploader from "react-firebase-file-uploader";
import {
    firebaseStorage
  } from "../../../helpers/firebase-config";

import IconFile from '../../../assets/svg/ic-actions-file.svg';

import HeaderModal from "../../../gb-components/HeaderModal";

const CadastroAnexo = ({ id, onClose, setAnexo, handleUploadSuccess }) => {

    const [ nomearquivo, setNomearquivo ] = useState('');
    const [ uploadProgress, setUploadProgress ] = useState(0);
    const [ isUploading, setIsUploading ] = useState(false);

    // const openModal = (item) => {
    //     setVisibleModal(true);
    //     setItemCirurgia(item);
    // }

    const handleUploadStart = () => {
        setIsUploading(true);
        setUploadProgress(0);
    }

    const handleProgress = progress => {
        console.log('progresso', progress)
        setUploadProgress(progress);
    }

    const handleUploadError = error => {
        setIsUploading(false);
        console.log('erro ao fazer upload',error);
    };

    const onSuccess = (filename) => {
        setIsUploading(false);
        setUploadProgress(100);
        handleUploadSuccess(filename);
    }

    return(
      <>
        <div className="row" style={{maxWidth:700}}>
            <div className="col-sm-12">
           
            <HeaderModal title="Para fazer upload de PDF das receitas e atestado, usar o campo abaixo"/>
            {/* <p>*Apenas PDF</p> */}
            <div className="row">
                <div className="col-sm-12 col-md-6">
                <InputIcon
                    placeholder="Digite o nome do arquivo"
                    type="text"
                    id="arquivo"
                    value={nomearquivo}
                    onChange={text => setNomearquivo(text)}
                    icon={IconFile}
                    style={{width: '100%'}}
                />
                </div>

                <div className="col-sm-12 col-md-6">
                    <label className="gb-lbl-anexo">
                        Escolher arquivo
                        <FileUploader
                            hidden
                            label="Arquivo"
                            name="image-uploader-multiple"
                            randomizeFilename
                            storageRef={firebaseStorage.ref(
                            "receitas"
                            )}
                            onUploadStart={handleUploadStart}
                            onUploadError={handleUploadError}
                            onUploadSuccess={onSuccess}
                            onProgress={handleProgress}
                            multiple={false}
                        />
                    </label>
                </div>
            </div>
            <div className="row">

                <div className="col-sm-12 mt-3" >
                <button
                    className="btn gb-button to-form full"
                    onClick={() => {setAnexo(nomearquivo); onClose()}}
                >
                    Salvar
                </button>
                </div>
            </div>
            <br /> <br />
            </div>
        </div>
      </>
    )
}

export default CadastroAnexo;